import React from 'react';
import MyObjectivesPage from '../progress/MyObjectivessPage';
import ReportLayout from './ReportLayout';

export default function ObjectivesReportPage() {
  return (
    <ReportLayout
      badge="Objectives"
      title="My Objectives Report"
      description="Review your self objectives in one place and use the print dialog to generate a PDF snapshot."
    >
      <MyObjectivesPage reportMode />
    </ReportLayout>
  );
}
